import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
import { ActivatedRoute, Router } from '@angular/router'
import { Subscription } from 'rxjs';
import { NotiService } from '@app/noti.service';

declare var $: any, moment: any

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  combinedAddressList: any
  combinedAddressListEn: any
  form: FormGroup
  isCompany = false
  isForeign = false

  cookieData: any

  submitted = false

  contact: any

  isConsentAccept = false
  isShownConsent = false

  allowNews = false
  PortalUser: any;
  TokenID: any;
  TokenP: any;

  EmailBeforeChange: any;
  EmailAfterChange: any;

  lang = "th"
  
  private notiSubscription: Subscription;
  
  constructor(
    private router: Router,
    private Route: ActivatedRoute,
    private fb: FormBuilder,
    private util: UtilService,
    private apiService: ApiService,
    private notiService: NotiService) {
    this.form = this.fb.group({
      dpa_companyname: "",
      dpa_companytypeid: "",
      dpa_registrationid: "",

      dpa_authorizedperson: "",
      dpa_authorizedperson_idcard: "",
      dpa_authorizedperson_telephone: "",

      contactid: "",

      firstname: "",
      lastname: "",
      dpa_idcard: "",
      telephone1: "",
      emailaddress1: ['', this.emailValidator],
      birthdate: "",
      dpa_accountno: ['', Validators.required],
      dpa_contact_homeno: ['', Validators.required],
      dpa_contact_moo: "",
      dpa_contact_street: "",
      dpa_contact_subdistict: "",
      dpa_contact_distict: "",
      dpa_contact_province: "",
      dpa_contact_postcode: "",
      dpa_contact_country: "",

      dpa_contact_subdistictname: "",
      dpa_contact_distictname: "",
      dpa_contact_provincname: "",
      dpa_contact_postcodename: "",
      dpa_contact_countryname: "",

      dpa_allowemail: false,
      dpa_allowsms: false,
      dpa_portalflag: true,
      pid: ""
    });
  }

  ngOnDestroy() {
    if(this.notiSubscription){
      this.notiSubscription.unsubscribe();
    }
  }

  async ngOnInit() {    
    let thisTs = this

    this.Route.queryParams.subscribe((Params: any) => {
      this.TokenID = Params["id"];
    });

    
      // boy add
        
      let para = "dpaCode=PRIVACY_POLICY";
      let tmp: any = await this.apiService.get("crmservice", "getPolicy", para); 
      if(!this.util.IsNullOrUndefined(tmp.policyDetail))
        {
          $("#proPolicy").html(tmp.policyDetail);
        }
      // boy add

    this.util.ShowWaiting(true);
    if (this.TokenID != null && this.TokenID != "" && this.TokenID != undefined) {
      this.TokenP = await this.GetToken();
      if (this.TokenP.username == undefined) {
      
        this.util.ErrorDialog("Invalid token.");
        $("#btnMainConfirm").off('click');

        let thisTs = this;
        $("#btnMainError").click(async function () {
          thisTs.router.navigate(["/mainmenu/index"])
        });
        $("#btnSave").attr("disabled", "disabled");
      }
      else {
        let dataToken:any = {
          contactid: this.TokenP.usernameidno,
          emailaddress1: this.TokenP.username
        }
        
        let Res = await this.apiService.post("crmservice", "updateContactEmail", dataToken);

        this.util.SuccessDialog("ระบบทำการแก้ไขและบันทึกข้อมูลเรียบร้อยแล้ว")
          $("#btnSuccessOK").click(async function () {
            thisTs.router.navigate(["/mainmenu/index"])
          });
      }
    }

    this.PortalUser = JSON.parse(localStorage.getItem("dpa_portal"));

      if (this.PortalUser == null || this.PortalUser.contactid == null || this.PortalUser.contactid == "") {
        this.util.WarningDialog("กรุณาเข้าสู่ระบบ");
        $("#btnWarningOK").off("click");
        $("#btnWarningOK").click(function () {
          thisTs.router.navigate(["/mainmenu/login"]);
        });
        return;
      }

    this.EmailBeforeChange = this.PortalUser.email;

    this.util.ShowWaiting(true)

    if(this.lang == "th"){
      $(".select2-en").hide()
      $(".select2-th").show()
    }
    else{
      $(".select2-th").hide()
      $(".select2-en").show()
    }

    this.notiSubscription = this.notiService.message.subscribe(_lang => {
      this.lang = _lang
      if(this.lang == "th"){
        $(".select2-en").hide()
        $(".select2-th").show()
      }
      else{
        $(".select2-th").hide()
        $(".select2-en").show()
      }
      if(this.contact != null){
        $(".select2").val(this.contact.dpa_contact_subdistict + "|" + this.contact.dpa_contact_distict + "|" + this.contact.dpa_contact_province + "|" + this.contact.dpa_contact_postcode + "|" + this.contact.dpa_contact_country).trigger('change')
      }
      
      //this.bindAddress(this.lang)
    });

    this.cookieData = JSON.parse(localStorage.getItem("dpa_portal"))
    if(this.cookieData == null){
      this.cookieData = {}
    }

    function matchCustom(params: any, data: any) {
      // If there are no search terms, return all of the data
      if ($.trim(params.term) === '') {
        return data;
      }

      // Do not display the item if there is no 'text' property
      if (typeof data.text === 'undefined') {
        return null;
      }

      if (params.term.length > 1) {
        // `params.term` should be the term that is used for searching
        // `data.text` is the text that is displayed for the data object
        let cris = params.term.split(" ")
        let found = true
        for (var i = 0; i < cris.length; i++) {
          if (cris[i] != '' && data != null && data.text != null && data.text.toLowerCase().indexOf(cris[i].toLowerCase()) < 0) {
            found = false;
            return null
          }
        }
        if (found) {
          // You can return modified objects from here
          // This includes matching the `children` how you want in nested data sets
          return data;
        }

      }
      // Return `null` if the term should not be displayed
      return null;
    }

    $('.select2th').select2({
      matcher: matchCustom,
      placeholder: "โปรดพิมพ์รายละเอียดที่อยู่"
    });

    $('.select2en').select2({
      matcher: matchCustom,
      placeholder: "Please select your address."
    });

    $(".select2").on("change", function (e: any) {
      thisTs.addressChange(e.target.value)
    })

    await this.initdropdown()

    this.contact = await this.getContact()

    if (this.cookieData != null) {
      this.contact.pid = this.cookieData.pid
    }

    this.mapDataToForm(this.contact)
    $(".select2").val(this.contact.dpa_contact_subdistict + "|" + this.contact.dpa_contact_distict + "|" + this.contact.dpa_contact_province + "|" + this.contact.dpa_contact_postcode + "|" + this.contact.dpa_contact_country).trigger('change')

    this.allowNews = this.contact.dpa_allowemail || this.contact.dpa_allowsms
    if (this.contact != null && this.contact.birthdate != null && this.contact.birthdate.trim().length != 0) {
      $("#dob").datepicker("setDate", new Date(this.contact.birthdate))
    }

    if (this.contact.dpa_companytypeid != null && this.contact.dpa_companytypeid.trim().length > 0) {
      this.isCompany = true

      let firstname = ""
      let lastname = ""
      try {
        let name: string = this.contact.dpa_authorizedperson.split(" ")
        if (name.length > 0) {
          if (name.length == 1) {
            firstname = name[0]
          }
          else if (name.length == 2) {
            firstname = name[0]
            lastname = name[1]
          }
          else {
            for (let i = 0; i < name.length - 1; i++) {
              firstname += " " + name[i]
            }
            firstname = firstname.trim()
            lastname = name[name.length - 1]
          }
        }
      }
      catch (e) {
        console.log(e)
      }

      this.form.controls["firstname"].setValue(firstname)
      this.form.controls["lastname"].setValue(lastname)
    }
    else{
      this.isForeign = this.contact != null && this.contact.dpa_passport != null && this.contact.dpa_passport.trim() != ''
    }
  }

  async GetToken() {
    let Res: any = await this.apiService.get("crmservice", "getToken", "token_id=" + this.TokenID);
    if (Res != null) {
      return Res;
    }
    return Res;
  }

  async initdropdown() {
    this.combinedAddressList = await this.apiService.getMasterAddress()
    this.setAddressEn()
    if(this.contact != null){
      $(".select2").val(this.contact.dpa_contact_subdistict + "|" + this.contact.dpa_contact_distict + "|" + this.contact.dpa_contact_province + "|" + this.contact.dpa_contact_postcode + "|" + this.contact.dpa_contact_country).trigger('change')
    }
  }

  setAddressEn(){
    if(this.combinedAddressList != null && this.combinedAddressList.length > 0){
      this.combinedAddressListEn = this.combinedAddressList.slice().sort(function(a: any, b: any) {
        if ( a.text_eng < b.text_eng ){
          return -1;
        }
        if ( a.text_eng > b.text_eng ){
          return 1;
        }
        return 0;
      });
    }
  }

  get formControl() {
    return this.form.controls;
  }

  addressChange(value: any) {
    let selected = this.combinedAddressList.filter((a: any) => a.id == value)
    if (selected != null && selected.length > 0) {
      let values = selected[0].id.split("|")
      let texts: any 
      if(this.lang == "th"){
        texts = selected[0].text.split(" | ")
      }
      else{
        texts = selected[0].text_eng.split(" | ")
      }

      this.formControl["dpa_contact_subdistict"].setValue(values[0])
      this.formControl["dpa_contact_distict"].setValue(values[1])
      this.formControl["dpa_contact_province"].setValue(values[2])
      this.formControl["dpa_contact_postcode"].setValue(values[3])
      this.formControl["dpa_contact_country"].setValue(values[4])

      this.formControl["dpa_contact_subdistictname"].setValue(texts[0])
      this.formControl["dpa_contact_distictname"].setValue(texts[1])
      this.formControl["dpa_contact_provincname"].setValue(texts[2])
      this.formControl["dpa_contact_postcodename"].setValue(texts[3])
      this.formControl["dpa_contact_countryname"].setValue(texts[4])
    }
    else {
      this.formControl["dpa_contact_subdistict"].setValue("")
      this.formControl["dpa_contact_distict"].setValue("")
      this.formControl["dpa_contact_province"].setValue("")
      this.formControl["dpa_contact_postcode"].setValue("")
      this.formControl["dpa_contact_country"].setValue("")

      this.formControl["dpa_contact_subdistictname"].setValue("")
      this.formControl["dpa_contact_distictname"].setValue("")
      this.formControl["dpa_contact_provincname"].setValue("")
      this.formControl["dpa_contact_postcodename"].setValue("")
      this.formControl["dpa_contact_countryname"].setValue("")
    }
  }

  emailValidator(control: any) {
    if (control.value) {
      const matches = control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
      return matches ? null : { 'invalidEmail': true };
    } else {
      return null;
    }
  }

  async save() {
    this.submitted = true
    if (this.form.valid && this.isValidForm()) {
      this.util.ShowWaiting(true)
      let dob: string = $('#dob').val()
      if (dob == null || dob.trim().length == 0) {
        this.formControl["birthdate"].setValue("")
      }
      else {
        //this.formControl["birthdate"].setValue($('#dob').data('datepicker').date.toISOString())
        this.formControl["birthdate"].setValue($("#dob").datepicker({ dateFormat: "dd/MM/yyyy" }).val())
      }

      if(this.isCompany){
        this.form.controls["dpa_authorizedperson"].setValue(this.form.get("firstname").value + " " + this.form.get("lastname").value);
        //this.form.controls["dpa_authorizedperson_idcard"].setValue(this.form.get("dpa_idcard").value);
        //this.form.controls["dpa_authorizedperson_telephone"].setValue(this.form.get("telephone1").value);
        this.form.controls["firstname"].setValue("")
        this.form.controls["lastname"].setValue("")
        this.form.controls["dpa_idcard"].setValue("")
      }
      this.form.controls["dpa_allowemail"].setValue(true)
      this.form.controls["dpa_allowsms"].setValue(true)

      this.EmailAfterChange = this.form.get("emailaddress1").value;
      this.form.controls["emailaddress1"].setValue(this.EmailBeforeChange);

      await this.apiService.postCustomApi("User", "UpdatePortalProfile", this.form.value).then((res: any) => {
        if (this.util.isSuccessResponse(res) && res == this.form.controls["contactid"].value) {

          this.registerDROS();
          let thisTs = this
          
          var txtSuccess = "ระบบทำการแก้ไขและบันทึกข้อมูลเรียบร้อยแล้ว ";
          if (this.EmailAfterChange != this.EmailBeforeChange){
            
              txtSuccess += "<br> กรุณายืนยันการเปลี่ยน Email จาก link ที่ส่งไปที่เมล์ล่าสุดที่ทำการแก้ไข";
           }

          this.util.SuccessDialog(txtSuccess)
          $("#btnSuccessOK").click(async function () {
            thisTs.router.navigate(["/mainmenu/index"])
          });
        }
        else {
          this.util.ErrorDialog("บันทึกข้อมูลไม่สำเร็จ")
        }
        this.util.ShowWaiting(false)
      })
    }
  }

  async SendEmail(TokenID: string) {
    let MailObj: any = {
      contactid: this.PortalUser.contactid,
      dpa_name: this.PortalUser.firstname + " " + this.PortalUser.lastname
    };

    let url = this.util.baseUrl() + "/mainmenu/profile?id=" + TokenID

    var MailContent = "เรียน คุณ" + this.PortalUser.firstname + " " + this.PortalUser.lastname + "<br /><br />" +
      "   คุณได้ทำการเปลี่ยน Email ในระบบ Customer Web Portal ของสถาบันคุ้มครองเงินฝาก <br />" +
      "โปรดคลิกลิงค์ด้านล่างเพื่อทำการยืนยันว่า Email ที่เปลี่ยนนี้ถูกต้อง และทำการบันทึกข้อมูล <br /><br />" +
      '<a target="_blank" href="' + url + '">Confirm Email</a><br /><br />' +
      "ขอแสดงความนับถือ <br />" +
      "สถาบันคุ้มครองเงินฝาก <br />" +
      "อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์ <br />" +
      "ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต <br />" +
      "แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900 <br />" +
      "โทร : 02-272-0300";
    MailObj.dpa_description = MailContent;
    MailObj.dpa_emailaddress = this.EmailAfterChange;
    let Res = await this.apiService.post("crmservice", "sendEmailUpdate", MailObj);
    return Res;
  }

  close() {
    window.close()
  }

  telephoneOnly(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {

      if (charCode == 35 || charCode == 44) {
        return true
      }
      return false;
    }
    return true;
  }

  numberOnly(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  async getContact() {
    let para = "contactid=" + this.cookieData.contactid
    let tmp: any = await this.apiService.get("crmservice", "contact", para)
    return tmp[0]
  }

  consentAcceptChange(target: any) {
    this.isConsentAccept = target.checked
    if(!this.isShownConsent){
      this.showConsent()
      this.isShownConsent = true
    }
  }

  newsAllowChange(target: any) {
    this.form.controls["dpa_allowemail"].setValue(target.checked)
    this.form.controls["dpa_allowsms"].setValue(target.checked)
  }

  showConsent() {
    this.isShownConsent = true
    $("#consentModal").modal('show');
  }

  mapDataToForm(data: any) {
    Object.keys(data).forEach((key) => {
      if (this.form.controls[key]) {
        this.form.controls[key].setValue(data[key])
      }
      else {
        this.form.addControl(key, new FormControl(data[key]));
      }
    });
    setTimeout(() => {
      this.util.ShowWaiting(false)
    }, 600);
  }

  async registerDROS() {
    //let idcard = this.form.get("dpa_personaltypeidname").value.includes("ต่างชาติ") ? this.form.get("dpa_passport").value : this.form.get("dpa_idcard").value;
    let idcard = this.form.get("dpa_idcard").value;
    if(this.isCompany)
    {
      idcard = this.form.get("dpa_registrationid").value
    }
    let para = "dpa_id=" + idcard + "&telephoneno=&fullname=&CRM05=false&CRM04=false&CRM03=false&CRM02=false&CRM07=false&CRM06=true";
    let tmp: any = await this.apiService.get("crmservice", "contactDros", para);
    if (!this.util.IsNullOrUndefined(tmp.CRM06)) {
      let UID = tmp.CRM06.UID;
      let SubdistictCode: string = "";
      let PostalName: string = "";
      let SubdistictObj = await this.apiService.postCustomApi("master", "Subdistrict", { id: this.form.get("dpa_contact_subdistict").value });
      let PostalObj = await this.apiService.postCustomApi("master", "Postalcode", { id: this.form.get("dpa_contact_postcode").value });
      if (!this.util.IsNullOrUndefined(SubdistictObj)) { SubdistictCode = SubdistictObj[0].dpa_code; }
      if (!this.util.IsNullOrUndefined(PostalObj)) { PostalName = PostalObj[0].dpa_name; }
      let arrAddr: any = [];
      let rowAddr: any = {
        addressType: "2",
        addressNo: this.form.get("dpa_contact_homeno").value,
        villageName: null,
        floor: null,
        mooNo: this.form.get("dpa_contact_moo").value,
        soiName: null,
        streetName: this.form.get("dpa_contact_street").value,
        locationCode: SubdistictCode,
        zipcode: PostalName
      }

     let birthdateYYYYMMDD = ""
     if(this.form.get("birthdate").value != "")
     {
      birthdateYYYYMMDD = moment(this.form.get("birthdate").value).format("YYYY/MM/DD") ;
     }

      arrAddr.push(rowAddr);

      let rowSave: any = {
        uid: UID,
        idNo: idcard,
        title: null,
        firstName: !this.isCompany ? this.form.get("firstname").value : this.form.controls["dpa_companyname"].value,
        lastName: !this.isCompany ? this.form.get("lastname").value : "",
        birthdate: birthdateYYYYMMDD ,
        mobileNo: !this.isCompany ? this.form.get("telephone1").value : this.form.get("dpa_authorizedperson_telephone").value,
        email: this.EmailBeforeChange,
        address: arrAddr
      }

      
      console.log(rowSave);
      let Res = await this.apiService.post("DROS", "register", rowSave);
      console.log(Res);


      let Token:any = {
        contactid: idcard,
        emailaddress1: this.EmailAfterChange
      }

      let Res2 = await this.apiService.post("crmservice", "createToken", Token);
      if (Res2 != null) {
           //let token: any = this.util.AesDecryptDictValue(Res.json())
           if (this.EmailAfterChange != this.EmailBeforeChange){
            
            Res2 = await this.SendEmail(Res2["ticketnumber"]);
           }
        }
        console.log(Res2);
    }

  }

  isValidForm(){
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/profile/profile.component.ts